// extracted by mini-css-extract-plugin
export var bordered = "pricing-module--bordered--om8Ow";
export var button = "pricing-module--button--3djTm";
export var container = "pricing-module--container--1AOMU";
export var from = "pricing-module--from--31gdg";
export var info = "pricing-module--info--1hS7V";
export var price = "pricing-module--price--1x-Zb";
export var sliderContainer = "pricing-module--sliderContainer--2J-n8";
export var title = "pricing-module--title--19WLd";